export default __webpack_public_path__ + "static/media/button-search.min.bd33f4b8.svg";